import type { FaireProductEntity } from "../../entity_types/product";

export const p_ngvjjmwxks: FaireProductEntity = {
  token: "p_ngvjjmwxks",
  type: "product",
  name: "Sea Side Soap",
  brandName: "Iya Natural Skincare",
  imageUrl:
    "https://cdn.faire.com/fastly/b62f90d41c6bb57178bec611e60c31fbd7cbafffa7474494ad6931f9c59f8626.jpeg",
  priceDollars: 8,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/e7a215ceb0c3c5792e6b037f51b07bfe41558ac36cae848861e93c46354ef90c.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
